// Google驗證器綁定頁面翻譯
export default {
  title: "身分驗證器綁定",
  description: "為了您的帳戶安全，請先綁定身分驗證器再登入。",

  activationCodeLabel: "啟用碼",
  steps: {
    step1: "步驟1：打開身分驗證器，掃描上方的二維碼或輸入啟用碼",
    step2: "步驟2：將身分驗證器中的動態數字輸入下方的驗證碼框中進行綁定",
  },

  // 驗證碼輸入
  verification: {
    title: "驗證碼",
    placeholder: "請輸入動態驗證碼",
    confirm: "確認",
    timeExpired: "驗證時間過長，請刷新頁面重新登入！",
    success: "身分驗證器綁定成功",
  },
};
